function isLangIso(str) {
  return ["it", "en", "es", "de", "fr"].includes(str);
}

function getLangByUrl() {
  let pathname = new URL(window.location.href).pathname;
  let pathParts = pathname.split("/");

  if (pathParts.length >= 2 && isLangIso(pathParts[1])) {
    return pathParts[1];
  }

  return "it";
}

/* DEPRECATED - HANDLED BY WEGLOT APP */
function handlePageLocale() {
  // If current locale equals new locale
  if (Weglot.getCurrentLang() == getLangByUrl()) {
    return;
  }

  let formData = new FormData();
  formData.append("form_type", "localization");
  formData.append("utf8", "✓");
  formData.append("_method", "put");
  formData.append("return_to", new URL(window.location.href).pathname);
  formData.append("locale_code", Weglot.getCurrentLang());

  fetch("/localization", {
    method: "POST",
    body: formData,
  }).then(function (response) {
    if (response.ok) {
      window.location.href = response.url;
    }
  });
}

Weglot.on("languageChanged", function () {
  console.log("Weglot - languageChanged");
  handlePageLocale();
});

Weglot.on("initialized", function () {
  console.log("Weglot - initialized");
  console.log("Weglot - locale:", Weglot.getCurrentLang());

  if (Weglot.getCurrentLang() != getLangByUrl()) {
    console.log("Weglot - switching to:", getLangByUrl());
    Weglot.switchTo(getLangByUrl());
  }
});
/**/

$("body").on("click", ".hulkapps_discount_button", function () {
  var interval1 = setInterval(function () {
    if ($("body").find(".after_discount_price .final-total").length > 0) {
      var newhulkapps_total = $("body")
        .find(".after_discount_price .final-total")
        .text("Totale");
      clearInterval(interval1);
    }
  }, 5);
});

var interval1 = setInterval(function () {
  if ($("body").find(".after_discount_price .final-total").length > 0) {
    var newhulkapps_total = $("body")
      .find(".after_discount_price .final-total")
      .text("Totale");
    clearInterval(interval1);
  }
}, 5);

$(document).ready(function () {
  $("body").on("click", ".privacyrequired", function () {
    console.log("evento chiamato");
    if ($("#agree").is(":checked")) {
      console.log("siamo entrati nell if");
      $(this).submit();
    } else {
      alert("Devi accettare le privacy policy per poter continuare.");
      return false;
    }
  });
});

/* nuova funzione pagina form OTP */
$(document).ready(function () {
  if ($("body.template-login").length) {
    setTimeout(function () {
      $("#eoshTEmail").click();
      $(".show_loading_login").hide();
    }, 1500);
  }
});

/* + Microtask #5168 */
$(document).ready(function () {
  if (window.innerWidth <= 768) {
    setTimeout(function () {
      $("#launcher").css("bottom", "90px");
    }, 5000);
  }
});
/* - Microtask #5168 */

/* animazione blocco descrizione delle collezzioni */
// Ottieni il riferimento agli elementi del DOM

$(document).ready(function () {
  var readMoreButton = $(
    "body.template-collection span.readmore-container-collection span.readmore-text-collection"
  );
  var readLessButton = $(
    "body.template-collection span.readless-container-collection span.readless-text-collection"
  );
  var descriptionCollectionTruncate = $("div.description-collection-truncate");
  var descriptionCollectionLong = $("div.description-collection-long");

  // descriptionCollectionLong.css('display', 'none');

  readMoreButton.click(function () {
    descriptionCollectionTruncate.css("display", "none");
    descriptionCollectionLong.css("display", "block");
    readMoreButton.css("display", "none");
    readLessButton.css("display", "block");
  });

  readLessButton.click(function () {
    descriptionCollectionTruncate.css("display", "block");
    descriptionCollectionLong.css("display", "none");

    readMoreButton.css("display", "block");
    readLessButton.css("display", "none");
  });
});

/* Hover su menu per aprire sotto menu */
$(document).ready(function () {
  $(".f-site-nav__item--has-child").on("mouseenter", function (event) {
    event.currentTarget.querySelector("details").setAttribute("open", true);
    event.currentTarget
      .querySelector("summary")
      .setAttribute("aria-expanded", true);
  });

  $(".f-site-nav__item--has-child").on("mouseleave", function (event) {
    event.currentTarget.querySelector("details").removeAttribute("open");
    event.currentTarget
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  });
});

/* segnalazione 5309 */
// $(function () {
//   if (
//     $(
//       "div.site-header__element a.site-header__link span.hidden.font-button"
//     ).text() != "Account" &&
//     $(
//       "div.site-header__element a.site-header__link span.hidden.font-button"
//     ).text() != "Compte" &&
//     $(
//       "div.site-header__element a.site-header__link span.hidden.font-button"
//     ).text() != "Cuenta" &&
//     $(
//       "div.site-header__element a.site-header__link span.hidden.font-button"
//     ).text() != "Konto"
//   ) {
//     $('.f-site-nav__item[data-index="3"]').hide();
//   }
// });

/* S#7886 - Validazione UX di Carolina (19/10/2026), SERP mobile: una sola visualizzazione.
   Searchanise ricorda nel browser l'ultima vista scelta (griglia, lista o row) e la riapre alle visite successive.
   Su mobile il selettore e' nascosto (custom.css): qui la scelta salvata torna a "grid", la griglia a 2 colonne. */
(function () {
  try {
    if (/\/pages\/search-results-page/.test(location.pathname) && window.matchMedia('(max-width: 767px)').matches) {
      localStorage.setItem('snize-view-mode', '"grid"');
    }
  } catch (e) {}
})();
